<template>
  <div
    :class="`personal ${type == 'child' && !isMobile ? 'childPersonal' : ''} ${type == 'child' ? 'child' : ''} ${isMobile ? 'personal_mobile' : ''}`"
    @click="clickPage">
    <div :class="`itemCard ${type == 'child' && !isMobile ? type : ''}`">
      <div class="itemContentTitle" v-if="!(isMobile && type == 'child')">{{ type == 'personal' ?
      `参观人（最多选择${maxPersonal}位）` : '儿童' }}</div>
      <slot></slot>
      <div class="itemWarp" v-if="type == 'child'">
        <div class="contentTitle">是否携带儿童</div>
        <!-- {{  maxChildNum}} -->
        <el-radio-group v-model="hasChild" :disabled="!maxChildNum" @change="selectedHasChild"
          :style="isMobile ? 'margin-top: 0.1rem' : ''">
          <el-radio :label="1">否</el-radio>
          <!-- <el-radio :label="2">是(最多{{maxChildNum}}位)</el-radio> -->
          <el-radio :label="2">是(最多{{ maxChildNum }}位)</el-radio>
        </el-radio-group>
      </div>
      <div :class="`nameWarp ${type}`"
        v-if="type == 'personal' || (type == 'child' && hasChild == 2 && fillChildrenInfo)">
        <div :class="`nameBlock ${!delPersonal && selectIndexs.indexOf(index) > -1 ? 'selected' : ''}`"
          v-for="(item, index) in datas" :key="item.id" @click="selectName(item, index)">
          <div v-html="addSpaceBetweenChineseWords(item.personName)"></div>
          <!-- <div>{{item.personName+`   `}}</div> -->
          <!-- {{ containsChinese(item.personName)?addSpaceBetweenChineseWords(item.personName):item.personName }} -->
          <span v-if="delPersonal">-</span>
        </div>
        <div :class="`nameBlock add ${delPersonal ? 'saveDelData' : ''}`" @click="add">{{ delPersonal ? '完成' : '+' }}
        </div>
        <div class="nameDetail" v-for="(item, index) in selectIndexs" :key="item">
          <div>{{ datas[item] ? datas[item].personName : '' }}</div>
          <div v-if="type == 'personal'">{{ datas[item] ? datas[item].cardNum : '' }}</div>
          <div v-else class="age">{{ datas[item] ? datas[item].age : '' }}岁</div>
          <div class="buttonText" @click="edit(item)"></div>
          <div class="delNameIcon" @click="del(index)"></div>
        </div>
      </div>
      <div v-if="type == 'child' && !fillChildrenInfo && hasChild == 2" class="lineContent childNumber">
        <div class="name">儿童人数</div>
        <el-input v-model="childNumber" placeholder="请输入儿童人数" type="number" @input="changeNumber"></el-input>
      </div>
    </div>
  </div>
</template>

<script>
var msg
export default {
  data() {
    return {
      selectIndexs: [],
      hasChild: 1,
      delPersonal: false,
      childNumber: ''
    };
  },

  props: ['type', 'datas', 'maxChildNum', 'maxPersonal', 'needPersonalVoucher', 'isMobile', 'fillChildrenInfo'],

  methods: {
    // 数量变化
    changeNumber(value) {
      console.log(value)
      console.log(this.maxChildNum)
      if (value > parseInt(this.maxChildNum)) {
        this.childNumber = this.maxChildNum
      }
      this.$emit('changeChildNumber', this.childNumber)
    },
    clickPage() {
      console.log(msg)
      if (msg) {
        msg.close()
      }
    },
    containsChinese(str) {
      return /[\u4e00-\u9fff]/.test(str)&&str.length==2;
    },
  addSpaceBetweenChineseWords(text) {
    console.log('text.length')
    console.log(text)
    console.log(text.length)
    if(text.length==2){
      return text[0]+'&nbsp;&nbsp;&nbsp;'+text[1]
    }else{
      return text
    }
},
 

    //点击姓名更换
    // selectName(item, index) {
    //   this.clickPage()
    //   if (this.delPersonal) {
    //     this.selectIndexs = []
    //     return this.$emit('delData', index, this.type)
    //   }
    //   let s_index = this.selectIndexs.indexOf(index)
    //   if (s_index > -1) { //已选
    //     return this.selectIndexs.splice(s_index, 1)
    //   }
    //   console.log(this.selectIndexs.length)
    //   console.log(this.maxChildNum)
    //   if (this.type == 'child' && this.selectIndexs.length == this.maxChildNum) {
    //     msg =this.$message.error('携带儿童数量已到最大值')
    //   }
    //   if (this.type == 'personal' && this.selectIndexs.length == this.maxPersonal) {
    //     msg= this.$message.error('选择的参观人数已到最大值')
    //   }
    //   this.selectIndexs.push(index)
    // },
    selectName(item, index) {
      if (this.delPersonal && item.belongId) {
        this.selectIndexs.splice(index, 1)
        return this.$emit('delData', index, this.type)
      }
      if (this.delPersonal && !item.belongId) return
      let s_index = this.selectIndexs.indexOf(index)
      if (s_index > -1) { //已选
        return this.selectIndexs.splice(s_index, 1)
      }
      if (this.type == 'child' && this.selectIndexs.length == this.maxChildNum) {
        return this.$message.error('携带儿童数量已到最大值')
      }
      if (this.type == 'personal' && this.selectIndexs.length == this.maxPersonal) {
        return this.$message.error('选择的参观人数已到最大值')
      }
      this.selectIndexs.push(index)
    },
    edit(index) {
      this.$emit('editPersonal', index, this.type)
    },

    del(index) {
      this.selectIndexs.splice(index, 1)
    },

    add() {
      if (this.delPersonal) {
        this.selectIndexs = []
        return this.delPersonal = false
      }
      // if (this.datas.length >= 5) {
      //   alert('最多保存5位参观人，请先删除已存信息')
      //   return this.delPersonal = true
      // }
      this.$emit('handelShowAdd', true, this.type, 'add')

    },

    // 点击携带儿童
    selectedHasChild(val) {
      if (!val) return
      this.$emit('selectedHasChild', val)
    }
  },

  mounted() {
    if (this.type != 'personal') return
    this.selectIndexs.push(0)
  },

  created() {
  },

  computed: {

  },
  beforeDestroy() {
    if (msg) {
      msg.close()
    }
  },
  watch: {
    selectIndexs: {
      handler(val, oldVal) {
        console.log(val)
        this.$emit('changeSelectData', val, this.type)
      },
      deep: true //true 深度监听
    }
  }
}
</script>

<style scoped lang="scss">
.nameWarp {
  .nameBlock {
    position: relative;

    span {
      position: absolute;
      top: 0;
      left: 0.06rem;
      line-height: 0.2rem;
      color: #990000;
      font-weight: 700;
      transform: scale(2)
    }
  }

  .saveDelData {
    font-size: 0.4rem;
    line-height: 1rem;
  }

  .age {
    margin-left: 0.6rem;
    width: 3.5rem;
  }

  &.child {
    margin-top: 0.3rem;
  }

  .delNameIcon {
    width: 0.58rem;
    height: 0.58rem;
    background: url('../../assets/ticket/delete.png') 0 0/contain no-repeat;
  }

  .buttonText {
    background: url('../../assets/ticket/edit.png') 0 0/contain no-repeat;
  }
}
</style>
<style type="text/css" lang="scss">
.pcContent .personal {
  .nameWarp {
    .nameBlock {
      span {
        transform: scale(3);
        top: -0.05rem;
      }
    }

    .saveDelData {
      font-size: 0.15rem !important;
      line-height: 0.33rem;
    }
  }

  .buttonText,
  .delNameIcon {
    width: 25px !important;
    height: 25px !important;
    cursor: pointer;
  }

  .childNumber {
    margin-top: -15px;
    padding-bottom: 20px;

    .name {
      font-size: 26px;
      width: 120px;
    }

    .el-input,
    .el-input__inner {
      width: 300px;
      font-size: 24px;
      text-align: left;
    }
  }
}

.childPersonal {
  margin-top: 40px;

  .itemCard.child {
    padding: 0 90px;
  }

  .itemWarp {
    padding: 30px 0;
  }

  .nameWarp.child {
    margin-top: -20px !important;
    padding-bottom: 30px;
  }
}

.personal_mobile {
  .nameDetail {
    color: #666666;
    font-size: 0.364rem;

    div:nth-child(1) {
      width: 1.5rem;
      margin-left: 0.3rem;
    }

    div:nth-child(2) {
      width: 4rem;
      margin: 0 0.4rem 0 0.1rem;
    }
  }

  .buttonText {
    font-size: 0;
    width: 0.48rem !important;
    height: 0.48rem;
    margin-right: 0.5rem !important;
  }

  .contentTitle {
    font-size: 0.416rem;
  }
}
</style>
<style type="text/css" lang="scss">
.pcContent {
  .nameWarp {
    .nameBlock {
      span {
        transform: scale(3);
        top: -0.05rem;
      }
    }

    .saveDelData {
      font-size: 20px !important;
      line-height: 66px;
    }
  }

  .childNumber {
    margin-top: -15px;
    padding-bottom: 20px;

    .name {
      font-size: 26px;
      width: 120px;
    }

    .el-input,
    .el-input__inner {
      width: 250px;
      font-size: 24px;
      text-align: left;
    }
  }
}

.childPersonal {
  margin-top: 40px;

  .itemCard.child {
    padding: 0 90px;
    // border-bottom-left-radius: 0;
    // border-bottom-right-radius: 0;
  }

  .itemWarp {
    height: 50px !important;
    padding: 30px 0;
  }

  .nameWarp.child {
    margin-top: -10px !important;
    padding-bottom: 30px;
  }
}

.personal_mobile {
  .el-radio {
    margin-right: 0.6rem;
  }

  .el-radio-group {
    margin-left: 0.3rem;

    .el-radio__label {
      color: #B0A899;
    }
  }
}
</style>
